import http from "./http";

function getDeviceModel(data) {
  return http.post(`ModelList`, data);
}
function addDeviceModel(data) {
  return http.post(`AddModel`, data);
}
function updateDeviceModel(data) {
  return http.post(`UpdateDeviceModel`, data);
}
function deleteDeviceModel(data) {
  return http.post(`DeleteDeviceModel`, data);
}

const DeviceModelService = {
  getDeviceModel,
  addDeviceModel,
  updateDeviceModel,
  deleteDeviceModel,
};

export default DeviceModelService;
